export default "__VITE_ASSET__BhOv1Df4__"